export { EmojiSad as default } from './EmojiSad';
